import * as Sentry from '@sentry/react';
import dayjs from 'dayjs';

export const sentryCaptureException = (
  error: unknown,
  errorMsg: string,
  action = '',
  extra = '',
) => {
  const currentDateTime = dayjs().format();
  const generalTags = {
    currentTime: currentDateTime,
    errorMessage: `${errorMsg}`,
    error: `${error}`,
    siteName: JSON.parse(localStorage.getItem('selectedSite') || `{}`)?.selectedSite,
    disciplineName: JSON.parse(localStorage.getItem('selectedDiscipline') || `{}`)
      ?.selectedDiscipline?.split('(')[0]
      .trim(),
  };
  if (!action) {
    Sentry.captureException(error, {
      tags: generalTags,
    });
  } else {
    Sentry.captureException(error, {
      tags: {
        ...generalTags,
        action,
      },
      extra: {
        additionalData: JSON.stringify(extra),
        error,
      },
    });
  }
};

export default { sentryCaptureException };
